import React, { useEffect, useContext } from 'react'
import './App.css'
import Routes from './routes'
import { BrowserRouter as Router } from 'react-router-dom'
import { setAuthToken, setIPAddress } from './product/common/api'
import { CookiesProvider } from 'react-cookie'

import CustomHeadAlert from './custom/components/molecules/HeadAlert'

import AuthState from './product/context/auth/authState'
import CustomCommonState from './custom/context/common/commonState'
import VideoState from './product/context/video/videoState'
import ProductCommonState from './product/context/common/commonState'
import UserState from './product/context/user/userState'
import EmployeeState from './product/context/employee/empState'
import AlertState from './product/context/alert/alertState'
import CommunicationState from './product/context/communication/communicationState'
import BidDepositState from './product/context/bid_deposit/bidDepositState'
import TransactionState from './product/context/transaction/transactionState'
import CreditState from './product/context/credit/creditState'
import SettingState from './product/context/setting/settingState'
import ProductState from './product/context/product/productState'
import NewsState from './product/context/news/newsState'
import ReturnState from './product/context/return/returnState'
import ProductCustState from './custom/context/product/productState'

import UserProductState from './product/context/userProduct/productState'
import UserBuyerState from './product/context/userBuyer/buyerState'
import UserCommonState from './product/context/userCommon/commonState'
import InvoiceState from './product/context/invoice/invoiceState'
import CartState from './product/context/cart/cartState'
import LanguageManagerState from './product/context/languageManager/languageManagerState'
import ReportState from './product/context/report/reportState'
import { SnackbarProvider } from 'notistack'
import Alerts from './product/common/alert'
import { publicIpv4 } from 'public-ip'
import AuctionState from './product/context/auction/auctionState'
import AppointmentState from './product/context/appointment/appointmentState'
import BidState from './product/context/bid/bidState'
import NetSuiteState from './product/context/thirdParty/netsuite/netSuiteState'
import DynamicState from './product/context/dynamic/dynamicState'
import GitlabState from './product/context/thirdParty/gitlab/gitlabState'
import AsinState from './product/context/thirdParty/asin/asinState'
import ManifestState from './product/context/manifest/manifestState'
import UserCyberSourceCardState from './product/context/userThirdParty/payment/cybersource/card/cardState'
import UserVersaPayCardState from './product/context/userThirdParty/payment/versapay/card/cardState'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import {
    ThemeProvider,
    StyledEngineProvider,
    createTheme,
} from '@mui/material/styles'
import { theme } from './utils/UI/theme'

global.site_url = process.env.REACT_APP_DOMAIN
global.images_url = global.site_url + '/uploads/product/'

global.user_front_url = process.env.REACT_APP_FRONTEND_URL

global.ignoreStates = []
global.ignoreCountry = []
global.defaultCountry = 'US'

global.currency = '$'
global.initialPageLimit = 20

global.static_pages = {
    editor: 'tinymce',
    version: 'free',
}

global.communication_templates = {
    editor: 'tinymce',
    version: 'free',
}

global.additionalBidHistoryWinning = [
    {
        field: 'custom_projects_internalId',
        type: 'text',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Internal ID',
    },
    {
        field: 'custom_projects_itemId',
        type: 'text',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Item ID',
    },
    {
        field: 'auctionlot_title',
        type: 'text',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Lot',
    },
    {
        field: 'projects_title',
        type: 'text',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Product',
    },

    {
        field: 'proposed_amount',
        type: 'price',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Bid',
    },
    // {
    //     field: 'buynow_qty',
    //     type: '',
    //     sort: true,
    //     firstChild: false,
    //     disablePadding: false,
    //     label: 'Quantity',
    // },
    {
        field: 'users_email',
        type: 'text',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Email',
    },

    // {
    //     field: 'bidtopstatus',
    //     type: 'text',
    //     sort: false,
    //     firstChild: false,
    //     disablePadding: false,
    //     label: 'Bid Status',
    // },
    {
        field: 'projects_market_status',
        type: 'capitalize',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Lot Status',
    },
    {
        field: 'projects_sprice',
        type: 'price',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Start Price',
    },
    {
        field: 'created_at',
        type: 'datetime',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Bid Date Time',
    },
]

global.additionalBidHistory = [
    {
        field: 'custom_projects_internalId',
        type: 'text',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Internal ID',
    },
    {
        field: 'custom_projects_itemId',
        type: 'text',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Item ID',
    },
    {
        field: 'auctionlot_title',
        type: 'text',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Lot',
    },
    {
        field: 'projects_title',
        type: 'text',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Product',
    },

    {
        field: 'proposed_amount',
        type: 'price',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Bid',
    },
    // {
    //     field: 'buynow_qty',
    //     type: '',
    //     sort: true,
    //     firstChild: false,
    //     disablePadding: false,
    //     label: 'Quantity',
    // },
    {
        field: 'users_email',
        type: 'text',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Email',
    },

    // {
    //     field: 'bidtopstatus',
    //     type: 'text',
    //     sort: false,
    //     firstChild: false,
    //     disablePadding: false,
    //     label: 'Bid Status',
    // },
    {
        field: 'projects_market_status',
        type: 'capitalize',
        sort: false,
        firstChild: false,
        disablePadding: false,
        label: 'Lot Status',
    },
    {
        field: 'projects_sprice',
        type: 'price',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Start Price',
    },
    {
        field: 'created_at',
        type: 'datetime',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Bid Date Time',
    },
]

if (localStorage.token) {
    setAuthToken(localStorage.token)
}

const App = () => {
    useEffect(() => {
        async function fetchData() {
            const ipaddress = await publicIpv4()
            if (ipaddress) {
                setIPAddress(ipaddress)
            }
        }
        fetchData()
    }, [])

    return (
        <CookiesProvider>
            {/* <StyledEngineProvider injectFirst> */}
            <ThemeProvider theme={theme}>
                <CustomCommonState>
                    <ProductCommonState>
                        <AuthState>
                            <AlertState>
                                <UserState>
                                    <AuctionState>
                                        <ProductState>
                                            <NewsState>
                                                <UserProductState>
                                                    <UserBuyerState>
                                                        <UserCommonState>
                                                            <InvoiceState>
                                                                <CartState>
                                                                    <LanguageManagerState>
                                                                        <EmployeeState>
                                                                            <ReportState>
                                                                                <BidDepositState>
                                                                                    <TransactionState>
                                                                                        <AppointmentState>
                                                                                            <CommunicationState>
                                                                                                <SettingState>
                                                                                                    <VideoState>
                                                                                                        <DynamicState>
                                                                                                            <AsinState>
                                                                                                                <CreditState>
                                                                                                                    <ProductCustState>
                                                                                                                        <NetSuiteState>
                                                                                                                            <ManifestState>
                                                                                                                                <GitlabState>
                                                                                                                                    <ReturnState>
                                                                                                                                        <UserCyberSourceCardState>
                                                                                                                                            <UserVersaPayCardState>
                                                                                                                                                <LocalizationProvider
                                                                                                                                                    dateAdapter={
                                                                                                                                                        AdapterMoment
                                                                                                                                                    }
                                                                                                                                                >
                                                                                                                                                    <SnackbarProvider
                                                                                                                                                        maxSnack={
                                                                                                                                                            3
                                                                                                                                                        }
                                                                                                                                                    >
                                                                                                                                                        <BidState>
                                                                                                                                                            <div className="App">
                                                                                                                                                                <Alerts />
                                                                                                                                                                <CustomHeadAlert />
                                                                                                                                                                <Router>
                                                                                                                                                                    <Routes />
                                                                                                                                                                </Router>
                                                                                                                                                            </div>
                                                                                                                                                        </BidState>
                                                                                                                                                    </SnackbarProvider>
                                                                                                                                                </LocalizationProvider>
                                                                                                                                            </UserVersaPayCardState>
                                                                                                                                        </UserCyberSourceCardState>
                                                                                                                                    </ReturnState>
                                                                                                                                </GitlabState>
                                                                                                                            </ManifestState>
                                                                                                                        </NetSuiteState>
                                                                                                                    </ProductCustState>
                                                                                                                </CreditState>
                                                                                                            </AsinState>
                                                                                                        </DynamicState>
                                                                                                    </VideoState>
                                                                                                </SettingState>
                                                                                            </CommunicationState>
                                                                                        </AppointmentState>
                                                                                    </TransactionState>
                                                                                </BidDepositState>
                                                                            </ReportState>
                                                                        </EmployeeState>
                                                                    </LanguageManagerState>
                                                                </CartState>
                                                            </InvoiceState>
                                                        </UserCommonState>
                                                    </UserBuyerState>
                                                </UserProductState>
                                            </NewsState>
                                        </ProductState>
                                    </AuctionState>
                                </UserState>
                            </AlertState>
                        </AuthState>
                    </ProductCommonState>
                </CustomCommonState>
            </ThemeProvider>
            {/* </StyledEngineProvider> */}
        </CookiesProvider>
    )
}

export default App
